
import VueAxios from "vue-axios";
import axios from "axios";
//Vue.use(VueAxios, axios);
//Vue.use(Vuex)
//const this.$store.state.baseapi = "http://127.0.0.1:8000/api/";
export default {
    data() {
      return {
       
      }
    },
  
    created() {
     
    },
  
    methods: {
     
     GET_POA_FINANCIEROS: async function(data) {




      
      var result =  await axios
        ({
          method: 'GET',
          url: this.$store.state.baseapi+"poa_lineas_acciones/"+data.poa_lineas_acciones_id+"/poa_avance_financieros/" ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },








    CREAR_POA_FINANCIEROS: async function(data) {



      
      var result =  await axios
        ({
          method: 'POST',
          url: this.$store.state.baseapi+"poa_avance_financieros/" ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
          data:{
          //QUITAR COMILLAS SOLO EN DATA 
          avancesfinancieros:data.avancesfinancieros,
          poa_lineas_acciones_id:data.poa_lineas_acciones_id,
         /*  
            planeado_1:data.planeado_1,
            planeado_2:data.planeado_2,
            planeado_3:data.planeado_3,
            planeado_4:data.planeado_4,
            ejercido_1:data.ejercido_1,
            ejercido_2:data.ejercido_2,
            ejercido_3:data.ejercido_3,
            ejercido_4:data.ejercido_4,
          poa_capitulos_conac_id:data.poa_capitulos_conac_id,
          //poa_lineas_acciones_id:data.poa_lineas_acciones_id,
          idmunicipio:data.idmunicipio,
         */
             
              
               
          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },





    EDITAR_POA_FINANCIEROS: async function(data) {




      
      var result =  await axios
        ({
          method: 'PUT',
          url: this.$store.state.baseapi+"poa_avance_financieros/"+data.id ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
          data:{
            'planeado_1':data.planeado_1,
            'planeado_2':data.planeado_2,
            'planeado_3':data.planeado_3,
            'planeado_4':data.planeado_4,
            'ejercido_1':data.ejercido_1,
            'ejercido_2':data.ejercido_2,
            'ejercido_3':data.ejercido_3,
            'ejercido_4':data.ejercido_4,
          poa_capitulos_conac_id:data.poa_capitulos_conac_id,
       
         
            
          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },

    ELIMINAR_POA_FINANCIEROS: async function(data) {




      
      var result =  await axios
        ({
          method: 'delete',
          url: this.$store.state.baseapi+"poa_avance_financieros/"+data.id ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },
    },
  }